import { RootState } from '../types'

export const getHooks = (state: RootState) => state.hooks.hooks

export const getHookValidationResult = (state: RootState) => state.hooks.validationResult

export const isValidating = (state: RootState) => state.hooks.isValidating

export const selectedHook = (state: RootState) => state.hooks.selectedHook
